<template>
  <div class="machine">
    <div class="machine-block">
      <!-- 奖品列表 -->
      <div
        class="machine-block-row"
        v-for="(row, index1) in prize_list"
        :key="index1"
      >
        <div
          @click="showpop(prize)"
          class="machine-block-row-box"
          v-for="(prize, index2) in row"
          :key="index2"
        >
          <!-- 奖品图片 -->
          <div>
            <img :src="setRewardBg(prize.grid_number)" alt="">
            <img v-if="prize.img_url" :src="prize.img_url" />
          </div>
          <!-- 未选中 -->
          <div class="not-active" v-if="!isStartOver&&prize.sy_index !== activeCell"></div>
          <!-- 选中状态 -->
          <img
            class="active"
            v-if="!isStartOver&&prize.sy_index === activeCell"
            :src="
              require('@/assets/images/YuliApp/kudasaiChristmas/active@2x.png')
            "
          />
          <!-- <div class="machine-block-row-box-num">x{{ prize.value || 0 }}</div> -->
        </div>
      </div>
    </div>
    <!-- 抽中奖品展示 -->
    <div class="machine-result">
      <img :src="curGif" />
    </div>

    <!-- 上圆圈 -->
    <div class="top-circleAll">
      <div
        class="top-circleAll-radius"
        v-for="(item, index) in 12"
        :key="index"
      ></div>
    </div>
    <!-- 左边 -->
    <div class="left-circleAll">
      <div
        class="top-circleAll-radius"
        v-for="(item, index) in 11"
        :key="index"
      ></div>
    </div>
    <!-- 右边 -->
    <div class="right-circleAll">
      <div
        class="top-circleAll-radius"
        v-for="(item, index) in 11"
        :key="index"
      ></div>
    </div>

    <!-- 下 -->
    <div class="bottom-circleAll">
      <div
        class="top-circleAll-radius"
        v-for="(item, index) in 12"
        :key="index"
      ></div>
    </div>

    <!-- 额外背景元素 -->
    <div class="machine-bgExtra"></div>
  </div>
</template>
<script>
import {
  getRewardList,
  GetRewardClaim,
  GetCountDown,
} from "@/api/kudasaiChristmas.js";
import { onBeforeMount, nextTick, onMounted, ref, computed } from "vue";
import _ from "lodash";
import audioManager from "@/utils/audioManager";
import default_gif from "@/assets/images/YuliApp/kudasaiChristmas/default.gif";
import start_gif from "@/assets/images/YuliApp/kudasaiChristmas/start.gif";
import reward_bg1 from "@/assets/images/YuliApp/kudasaiChristmas/reward/bg_1@2x.png";
import reward_bg2 from "@/assets/images/YuliApp/kudasaiChristmas/reward/bg_2@2x.png";
import reward_bg3 from "@/assets/images/YuliApp/kudasaiChristmas/reward/bg_3@2x.png";
import reward_bg4 from "@/assets/images/YuliApp/kudasaiChristmas/reward/bg_4@2x.png";
import reward_bg5 from "@/assets/images/YuliApp/kudasaiChristmas/reward/bg_5@2x.png";
export default {
  components: {},
  props: {
    prizeListServe: {
      type: Array,
      default: () => [],
    },
    isStart: {
      type: Boolean,
      default: false,
    },
    resultId: {
      type: Number,
      default: -1,
    },
  },
  watch: {
    prizeListServe: {
      handler(value) {
        this.prize_list_serve = value;
        console.log("this.prize_list_serve", this.prize_list_serve);
        this.hanldePrizesData();
      },
      immediate: true,
      deep: true,
    },
    resultId:{
      handler(value){
        this.result_id = value
      }
    },

    isStart: {
      handler(value) {
        if (value) {
          this.aroundFunction(500, this.resultId);
          // this.curGif = start_gif;
          this.isStartOver = false
          audioManager.playEffect("lucky_go", false);
        }
      },
      immediate: true,
      deep: true,
    },
  },
  setup(props, { emit }) {
    const prize_row = [6, 2, 2, 2, 2, 6]; //每一行的奖品数据个数
    const prize_list = ref([]); //最终渲染的数据
    const prize_list_serve = ref([]); //来自服务的数据

    const activeCell = ref(0); //跑马灯
    // const defaultId = ref(6); //内定结果
    const timer = ref(null);

    const circleNum = ref(5); //跑几圈
    const cur_circleNum = ref(0); //当前跑到第几圈

    const is_start = ref(false);

    const is_get_result = ref(false);
    const result_info = ref(null);

    const curGif = ref(null);

    const isStartOver = ref(true)

    curGif.value = default_gif;

    const result_id_map = ref([]);

    const result_id  = ref(-1)

    onMounted(() => {
      // aroundFunction(500,51869625087950849);
    });

    // 使转动停止的方法
    const aroundStop = () => {
      console.log("清除定时器", timer.value);
      // 清除定时器
      clearTimeout(timer.value);
      timer.value = null;
      is_get_result.value = true;
      audioManager.playEffect("win");

      emit("handleEnd", false, is_get_result, result_info);
      setTimeout(() => {
        // activeCell.value = 0;
        cur_circleNum.value = 0;
        curGif.value = default_gif;
      isStartOver.value = true
      }, 1000);

      // return null;
    };

    const aroundFunction = (time) => {
      const target_sy_index = result_id_map.value.findIndex(
        (item) => result_id.value === item
      );
      if (
        target_sy_index === activeCell.value &&
        cur_circleNum.value === circleNum.value
      ) {
        return aroundStop();
      }
      // }
      timer.value = setTimeout(() => {
        let ms = time - 30;

        activeCell.value += 1;

        if (activeCell.value === 20) {
          activeCell.value = 0;
          cur_circleNum.value += 1;
        }

        if (ms < 50) {
          ms = 50;
        }
        // 转动间隔的最大值
        if (ms > 200) {
          ms = 200;
        }
        aroundFunction(ms);
      }, time);
    };

    /**
     * 展示奖品列表配置
     */
    const hanldePrizesData = () => {
      const loopTimes = [];
      const prize_config = [];
      let prizeLayout = [];
      const id_map = [];
      for (let i = 0; i < 20; i++) {
        loopTimes.push(i);
      }

      let sy_index = 0;
      loopTimes.forEach((item, index) => {
        const tidai = _.get(prize_list_serve.value[0], "img_url", "");
        const img_url = _.get(prize_list_serve.value[index], "img_url", tidai);
        const grid_number = _.get(
          prize_list_serve.value[index],
          "grid_number",
          "0"
        );
        const value = _.get(prize_list_serve.value[index], "value", 0);
        const count = _.get(prize_list_serve.value[index], "count", 0);
        const name = _.get(prize_list_serve.value[index], "name", 0);
        const description = _.get(
          prize_list_serve.value[index],
          "description",
          0
        );
        const prizeObj = {
          sy_id: sy_index,
          img_url: img_url,
          sy_index: index < 6 ? sy_index : 0,
          value,
          count,
          name,
          description,
          grid_number,
        };
        prize_config.push(prizeObj);
        id_map.push(grid_number);
        result_id_map.value = id_map;
        sy_index++;
      });

      let start = 0;
      let row_diff = 13;
      prize_row.forEach((item, index) => {
        let slice_arr = [];
        if (index === 0 && item === 6) {
          slice_arr = prize_config.slice(start, start + item);
          start = start + item;
        } else if (index === 5 && item === 6) {
          slice_arr = prize_config.slice(start, start + item).reverse();
          start = start + item;
        }

        if (item === 2) {
          slice_arr.push(prize_config[start + row_diff], prize_config[start]);
          row_diff -= 2;
          start = start + 1;
        }
        prizeLayout.push(slice_arr);
      });
      prize_list.value = hanldePrizelist(prizeLayout);
      // prize_list.value = prizeLayout;
      console.log("prize_list", prize_list.value);
    };

    /**
     * 生成跑马灯时的索引
     */
    const hanldePrizelist = (prizeLayout) => {
      const data = JSON.parse(JSON.stringify(prizeLayout));

      data[1][0].sy_index = 19;
      data[1][1].sy_index = 6;

      data[2][0].sy_index = 18;
      data[2][1].sy_index = 7;

      data[3][0].sy_index = 17;
      data[3][1].sy_index = 8;

      data[4][0].sy_index = 16;
      data[4][1].sy_index = 9;

      data[5].forEach((item, index) => {
        item.sy_index = item.grid_number - 1;
      });

      return data;
    };

    /**
     * 请求抽奖结果
     */
    const requestGetResult = () => {
      return GetRewardClaim({ data: {} }).then((res) => {
        console.log("数据", res);
        return 1;
      });
    };

    const showpop = (item) => {
      emit("showpop", true, item);
    };

    const setRewardBg = computed(() => {
      return (g_id) => {
        switch (g_id) {
          case 1:
          case 5:
          case 7:
          case 9:
          case 12:
          case 14:
          case 16:
          case 19:
            return reward_bg3;
          case 2:
          case 4:
          case 8:
          case 11:  
          case 15:
          case 17:
          case 20:
            return reward_bg1;    
          case 3:
          case 13:
            return reward_bg2;
          case 6:
          case 10:
          case 18: return reward_bg5;
        }
      }
    })
   
    return {
      hanldePrizesData,
      aroundFunction,
      showpop,
      prize_list,
      prize_list_serve,
      activeCell,
      timer,
      is_start,
      curGif,
      setRewardBg,
      isStartOver,
      result_id
    };
  },
};
</script>

<style lang="less" scoped>
.machine {
  position: relative;
  margin: 0 auto;
  width: 332px;
  height: 330px;
  background: url("~@/assets/images/YuliApp/kudasaiChristmas/bg.png");
  background-size: 100% 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  &-block {
    width: 298px;
    min-height: 298px;
    // background-color: #a39bb1;
    padding: 4px;
    &-row {
      width: 100%;
      height: 48px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 2px;
      &-box {
        position: relative;
        box-sizing: border-box;
        width: 48px;
        height: 48px;
        border-radius: 2px;
        opacity: 1;
        background-color: #a39bb1;
        border: 2px solid #605879;
        // background: rgba(0, 0, 0, 0.1);
        img {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          border-radius: 2px;
        }
        &-num {
          font-size: 10px;
          font-weight: 700;
          line-height: 12px;
          text-align: right;
          color: #fff;
          position: absolute;
          bottom: 0;
          right: 2px;
        }
      }
      .active {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        z-index: 10;
        width: 50px;
        height: 50px;
        // border: 2px solid #ffffff;
        // background: url("~@/assets/images/YuliApp/kudasaiChristmas/active@2x.png");
        // background-size: 100% 100%;
      }
      .not-active {
        position: absolute;
        left: 50%;
        top: 50%;
        z-index: 9;
        transform: translate(-50%, -50%);
        width: 48px;
        height: 48px;
        background: rgba(0, 0, 0, 0.2);
      }
    }
    .machine-block-row:last-child {
      margin-bottom: 0px;
    }
  }

  &-result {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    align-items: center;
    justify-content: center;
    width: 195px;
    height: 195px;
    // border-radius: 2px;
    // opacity: 1;
    // background: rgba(172, 162, 188, 1);
    background: url("~@/assets/images/YuliApp/kudasaiChristmas/prize_bg.png");
    background-size: 100% 100%;
    img {
      // width: 100%;
      width: 176px;
      height: 176px;
    }
  }

  .top-circleAll,
  .left-circleAll,
  .right-circleAll,
  .bottom-circleAll {
    box-sizing: border-box;
    // padding-top: 1px;
    height: 10px;
    width: 310px;
    display: flex;
    justify-content: space-between;
    // align-items: center;
    position: absolute;
    top: 2.2px;
    left: 11px;
    &-radius {
      box-sizing: border-box;
      flex-shrink: 0;
      width: 6px;
      height: 6px;
      opacity: 1;
      border-radius: 50%;
    }
    // 开灯色
    @lightOnColor: #FFF173;
    @lightOnShadow: 0 0 2px 0 rgba(255, 203, 69, 0.5), 0 0 1px 0 rgba(255, 243, 134, 0.5);
    // 关灯色
    @lightOffColor: #FFFEF4;
    @lightOffShadow: 0 0 2px 0 rgba(255, 203, 69, 0.5), 0 0 1px 0 rgba(255, 243, 134, 0.5); 
    .top-circleAll-radius:nth-of-type(even) {
      background: @lightOnColor;
      box-shadow: @lightOnShadow;
      animation: evenShan 1s ease-in-out infinite alternate;
    }
    .top-circleAll-radius:nth-of-type(odd) {
      background: @lightOffColor;
      box-shadow: @lightOffShadow;
      animation: oddShan 1s ease-in-out infinite alternate;
    }
    @keyframes evenShan {
      0% {
        // transform: scale(1);
        background: @lightOnColor;
        box-shadow: @lightOnShadow;
      }
      100% {
        // transform: scale(0.8);
        background: @lightOffColor;
        box-shadow: @lightOffShadow;
      }
    }
    @keyframes oddShan {
      0% {
        background: @lightOffColor;
        box-shadow: @lightOffShadow;
      }
      100% {
        background: @lightOnColor;
        box-shadow: @lightOnShadow;
      }
    }
  }
  .left-circleAll {
    position: absolute;
    left: 1px;
    top: 20px;
    height: 290px;
    width: 10px;
    flex-direction: column;
    align-items: center;
  }
  .right-circleAll {
    z-index: 10;
    position: absolute;
    left: unset;
    right: 1.3px;
    top: 20px;
    height: 290px;
    width: 10px;
    flex-direction: column;
    align-items: center;
  }
  .bottom-circleAll {
    bottom: -0.8px;
    top: unset;
  }

  &-bgExtra{
    position: absolute;
    width: 370px;
    height: 330px;
    background: url("~@/assets/images/YuliApp/kudasaiChristmas/bg_extra.png");
    background-size: 100% 100%;
    z-index: 0;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>
